/* eslint-disable import/prefer-default-export */

export const isLocalEnvironment = () =>
  window.location.hostname === "localhost";
